import {
  API_FEE_ADMIN_CALCULATE,
  API_FEE_CALCULATE,
  API_GENERAL_GET_CITY,
  API_GENERAL_GET_COUNTRY,
  API_GENERAL_GET_EVENT,
  API_GENERAL_GET_OCCUPATION,
  API_GENERAL_GET_STATE,
  API_GENERAL_GET_TIMEZONES,
  API_SEND_EMAIL_NOTIFICATION,
  API_UPDATE_TIMEZONE,
  API_USER_GET_BADGES,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";

export const getCountriesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_GENERAL_GET_COUNTRY,
  });
};
export const getStatesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_GENERAL_GET_STATE,
  });
};
export const getCitiesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_GENERAL_GET_CITY,
  });
};
export const getOccuoationAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_GENERAL_GET_OCCUPATION,
  });
};
export const getEventsAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_GENERAL_GET_EVENT,
  });
};
export const updateTimeZoneAPI = ({ timeZoneId }) => {
  let postData = {
    timezone_id: timeZoneId,
  };
  return axiosMiddleware({
    method: "put",
    url: API_UPDATE_TIMEZONE,
    data: postData,
  });
};
export const getTimeZonesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_GENERAL_GET_TIMEZONES,
  });
};
export const getBadgesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_USER_GET_BADGES,
  });
};
export const calculateFeeAPI = ({ userId, eventId, walletId }) => {
  let postData = {
    userId,
    eventId,
    walletId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_FEE_CALCULATE,
    data: postData,
  });
};

export const calculateAdminFeeAPI = ({ adminId, eventId, walletId }) => {
  let postData = {
    adminId,
    eventId,
    walletId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_FEE_ADMIN_CALCULATE,
    data: postData,
  });
};
export const sendNewMailAPI = ({ agentIds, userIds, subject, message }) => {
  let postData = {
    agent_ids: agentIds,
    user_ids: userIds,
    subject,
    message,
  };
  return axiosMiddleware({
    method: "post",
    url: API_SEND_EMAIL_NOTIFICATION,
    data: postData,
  });
};
export const getMailServicesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: "setting/mailers",
  });
};
export const changeMailServiceAPI = ({ id }) => {
  let postData = {
    value: id,
  };
  return axiosMiddleware({
    method: "put",
    url: "setting/update-mailer",
    data: postData,
  });
};
export const updateNumberlandLimitAPI = ({ value }) => {
  let postData = {
    value,
  };
  return axiosMiddleware({
    method: "put",
    url: "setting/update-numberland-limit",
    data: postData,
  });
};
export const getSettingsAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: "setting",
  });
};
